import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faGear } from '@fortawesome/pro-light-svg-icons';

export type ProLightGearProps = IconComponentProps;

export const ProLightGear = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightGearProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faGear}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faGear}
    />
  );
};

ProLightGear.displayName = 'ProLightGear';
